import React from "react";
import { getGovernorates } from "../../../MyApi/admin/governorates";
import { getCities } from "../../../MyApi/admin/cities";
import { getZones } from "../../../MyApi/zones";
import { useQuery } from "react-query";
import { getCountries } from "../../../MyApi/admin/countries/countries";
import Select from "react-select";
const AddressesInfo = ({ setAddressData, addressData ,lang  ,setArea }) => {
  //queries
  const { data: countriesData  ,isLoading: isCountryLoading} = useQuery("getCountries", getCountries);
  const { data: governorateData ,isLoading:isGovernorateLoading } = useQuery(
    ["getGovernorates", addressData.country_id],
    () => getGovernorates(addressData.country_id),
    { enabled: !!addressData.country_id }
  );
  const { data: citiesData  ,isLoading:isCityLoading} = useQuery(
    ["getCities", addressData.governote_id],
    () => getCities(addressData.governote_id),
    { enabled: !!addressData.governote_id }
  );
  const { data: zonesData  ,isLoading:isZonesLoading} = useQuery(
    ["getZones", addressData.city_id],
    () => getZones(lang,  addressData.city_id),  
    { enabled: !!addressData.city_id }
  );
  const countries = countriesData?.data?.countries || [];
  const governorates = governorateData?.data?.governorates || [];
  const cities = citiesData?.data?.cities || [];
  const zones = zonesData?.data?.zones || [];

  return (
    <div className="row">
      <div className="col-md-3">
        <label>الدولة</label>
        <Select
          options={countries}
          value={countries.find(c => c.id === addressData.country_id) || null}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          onChange={(selected) =>
            setAddressData((prev) => ({
              ...prev,
              country_id: selected?.id || null,
              governote_id: null,
              city_id: null,
              zone_id: null,
            }))   
          }
        />
      </div>

      <div className="col-md-3">
        <label>المحافظة</label>
        <Select
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={governorates.find(c => c.id === addressData.governote_id) || null}
          options={governorates}
          onChange={(selected) =>
            setAddressData((prev) => ({
              ...prev,
              governote_id: selected?.id || null,
              city_id: null,
              zone_id: null,
            }))
          }
          isDisabled={!addressData.country_id}
           placeholder={addressData.country_id && isGovernorateLoading ?"جاري فلترة المحافظات":"اختر"}
        />
      </div>

      <div className="col-md-3">
        <label>المدينة</label>
        <Select
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
                 value={cities.find(c => c.id === addressData.city_id) || null}
          options={cities}
          onChange={(selected) =>
            setAddressData((prev) => ({
              ...prev,
              city_id: selected?.id || null,
              zone_id: null,
            }))
          }
          isDisabled={!addressData.governote_id}
             placeholder={addressData.governote_id && isCityLoading ?"جاري فلترة المدن":"اختر"}
        />
      </div>

      <div className="col-md-3">
        <label>المنطقة</label>
        <Select
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          options={zones}
            value={zones.find(c => c.id === addressData.zone_id) || null}
          onChange={(selected) =>{
                  setAddressData((prev) => ({
              ...prev,
              zone_id: selected?.id || null,
            }))
            setArea(selected?.area)
            console.log('first', selected?.area)
          }
      
          }
          isDisabled={!addressData.city_id}
           placeholder={addressData.city_id && isZonesLoading ?"جاري فلترة المناطق":"اختر"}
        />
      </div>
    </div>
  );
};

export default AddressesInfo;
